import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import supabase from '../services/supabaseClient';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { isAuthenticated, checkWhitelistStatus, loading } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      // Give Supabase a moment to process the callback
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      if (isAuthenticated) {
        // Get the current session to check whitelist
        const { data: { session } } = await supabase.auth.getSession();
        if (session?.user) {
          const whitelisted = await checkWhitelistStatus(session.user.id);
          if (whitelisted) {
            navigate('/dashboard');
          } else {
            navigate('/pending-approval');
          }
        } else {
          navigate('/dashboard'); // Fallback
        }
      } else {
        setError('Authentication failed. Please try again.');
      }
    };

    if (!loading) {
      handleCallback();
    }
  }, [isAuthenticated, loading, navigate, checkWhitelistStatus]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {error ? (
        <>
          <div style={{ fontSize: '18px', color: '#c33' }}>{error}</div>
          <button
            onClick={() => navigate('/signin')}
            style={{
              padding: '10px 24px',
              backgroundColor: '#667eea',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            Back to Sign In
          </button>
        </>
      ) : (
        <>
          <div>Processing authentication...</div>
          <div
            style={{
              width: '40px',
              height: '40px',
              border: '4px solid #e0e0e0',
              borderTop: '4px solid #667eea',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
            }}
          />
          <style>{`
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          `}</style>
        </>
      )}
    </div>
  );
}
